import { gtFilter } from 'volta/utils/filters-utils';
import { restartableTask } from 'ember-concurrency';
import moment from 'moment-timezone';
import { ResourceName } from 'volta/models/import-histo';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { IWidgetArgs } from '../';
import type IntlService from 'ember-intl/services/intl';
import type StoreService from 'volta/services/store';
import type ImportHisto from 'volta/models/import-histo';
import { ImportsTableColumns } from 'volta/_pods/protected/import/controller';

export default class ImportStatusWidget extends Component<IWidgetArgs> {
  @service intl!: IntlService;
  @service store!: StoreService;
  @tracked imports: ImportHisto[] = [];

  resourceName = ResourceName;

  importHistoTask = restartableTask(async () => {
    try {
      const query = {
        page: {
          offset: 0,
          limit: 15
        },
        sort: '-createdAt',
        filter: {
          endedAt: gtFilter(moment().format('YYYY-MM-DDT00:00:00.000'))
        }
      };
      this.imports = (
        await this.store.query(this.resourceName.singular, query)
      ).toArray() as ImportHisto[];

      return this.imports;
    } catch (e) {
      defaultErrorHandler(e);
      return;
    }
  });

  get tableColumns() {
    return ImportsTableColumns(this.intl);
  }
}
